import styled from "styled-components";

import { FlexDiv } from "../../../../components/Atoms";

export const StyledFeatures = styled(FlexDiv)`
  flex-direction: column;
  gap: 8px;

  @media only screen and (max-width: 600px) {
    padding: 24px 16px 24px 16px;
  }
`;
